import { Panel } from "@ui/Panel";
import { type Accessor, createMemo, Show } from "solid-js";
import type { MentionData } from "./Mention";
import { ProfilePanelContent } from "./profilePanel/ProfilePanelContent";

type Props = {
	isOpen: Accessor<boolean>;
	mention: Accessor<MentionData | null>;
	onClose: () => void;
	/** See {@link ProfilePanelContent}'s prop of the same name. */
	summaryOnly?: boolean;
};

export const ProfilePanel = (props: Props) => {
	const title = createMemo(() => {
		const mention = props.mention();
		if (!mention) {
			return "Profile";
		}
		return mention.name ?? `@${mention.handle}`;
	});

	return (
		<Panel
			isOpen={props.isOpen}
			onToggle={props.onClose}
			title={title()}
			symbol="person"
			width="var(--panel-width, 480px)"
			class="profile-panel"
		>
			<Show when={props.mention()} keyed>
				{(mention) => (
					<ProfilePanelContent
						mention={mention}
						summaryOnly={props.summaryOnly}
					/>
				)}
			</Show>
		</Panel>
	);
};
